import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {MainComponent} from '@modules/main/main.component';
import {BlankComponent} from '@pages/blank/blank.component';
import {LoginComponent} from '@pages/login/login.component';
import {ProfileComponent} from '@pages/profile/profile.component';
import {RegisterComponent} from '@pages/register/register.component';
import {DashboardComponent} from '@pages/dashboard/dashboard.component';
import {AuthGuard} from '@guards/auth.guard';
import {NonAuthGuard} from '@guards/non-auth.guard';
import { PermissionsGuard } from '@guards/permissions.guard';
import {ForgotPasswordComponent} from '@pages/forgot-password/forgot-password.component';
import {RecoverPasswordComponent} from '@pages/recover-password/recover-password.component';
// import {SubMenuComponent} from '@modules/owner-management/sub-menu/sub-menu.component';
import { PilotListComponent } from '@modules/pilot-management/pilot-list/pilot-list.component';
const routes: Routes = [
    {
        path: '',
        component: MainComponent,
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        children: [
            {
                path: '',
                component: DashboardComponent,
                data: {
                    menu: 'na'
                },
                canActivate: [PermissionsGuard],
            },
            {
                path: 'profile',
                component: ProfileComponent,
            },
            {
                path: 'blank',
                component: BlankComponent
            },
            // {
            //     path: 'owner',
            //     component: SubMenuComponent
            // },
            //   {
            //     path: 'pilot',
            //     component: PilotListComponent
            // },
            {
                path: 'blank',
                component: BlankComponent
            },
            
             {
                path: 'global',
                loadChildren: () =>
                  import('./modules/global-configuration/global-configuration.module').then((mod) => mod.GlobalConfigurationModule),
                // canActivate: [PermissionsGuard],
                data: {
                    menu: 'pilot'
                },
            },
            {
                path: 'activity-log',
                loadChildren: () =>
                  import('./modules/activity-log/activity-log.module').then((mod) => mod.ActivityLogModule),
                // canActivate: [PermissionsGuard],
                data: {
                    menu: 'activity log'
                },
            },
             {
                path: 'pilot',
                loadChildren: () =>
                  import('./modules/pilot-management/pilot-management.module').then((mod) => mod.PilotManagementModule),
                // canActivate: [PermissionsGuard],
                data: {
                    menu: 'pilot'
                },
            },
            {
                path: 'owner',
                loadChildren: () =>
                  import('./modules/owner-management/owner-management.module').then((mod) => mod.OwnerManagementModule),
                // canActivate: [PermissionsGuard],
                data: {
                    menu: 'owner'
                },
            },
            {
                path: 'users',
                loadChildren: () =>
                  import('./modules/users/users.module').then((mod) => mod.UsersModule),
                canActivate: [PermissionsGuard],
                data: {
                    menu: 'users'
                },
            },
            {
                path: 'account-types',
                loadChildren: () =>
                  import('./modules/account-type/account-type.module').then((mod) => mod.AccountTypeModule),
                //canActivate: [PermissionsGuard],
                data: { menu: 'account types'},
            },
            {
                path: 'access-group',
                loadChildren: () => import('./modules/access-control/access-control.module').then(m => m.AccessControlModule),
                canActivate: [PermissionsGuard],
                data: {
                    menu: 'access group'
                },
            },
            {
                path: 'coupon',
                loadChildren: () =>
                  import('./modules/coupon/coupon.module').then((mod) => mod.CouponModule),
                canActivate: [PermissionsGuard],
                data: { menu: 'coupon'},
            },
        ]
    },
    {
        path: 'login',
        component: LoginComponent,
        canActivate: [NonAuthGuard]
    },
    {
        path: 'register',
        component: RegisterComponent,
        canActivate: [NonAuthGuard]
    },
    {
        path: 'forgot-password',
        component: ForgotPasswordComponent,
        canActivate: [NonAuthGuard]
    },
    {
        path: 'recover-password',
        component: RecoverPasswordComponent,
        canActivate: [NonAuthGuard]
    },
    {path: '**', redirectTo: ''}
];

@NgModule({
    imports: [RouterModule.forRoot(routes, {})],
    exports: [RouterModule]
})
export class AppRoutingModule {}
